import { useQuery } from '@tanstack/react-query';
import { UserWalletCompanyInfoService } from 'services/openapi';

import { CompanyWalletServiceQueryKeys } from '../constants';
import { GetListCompanyEntity } from '../../openapi/models/GetListCompanyEntity';
import { isEmpty } from 'lodash';

type GetListCompDTO = {
  // page: string;
  // pageSize: string;
};

export const useGetCompanyAllQuery = () => {
  const queryKey = [CompanyWalletServiceQueryKeys.GET_COMPANY_INFO];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<GetListCompanyEntity, Error>({
    queryKey,
    queryFn: () => UserWalletCompanyInfoService.companyControllerFindAll(),
    retry: 0,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    // enabled: !isEmpty(variables)
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data: data?.data,
    isError,
    queryKey,
    refetch,
  };
};
